import { createContext, useContext } from 'react';

/**
 * Whether the column a component sits in has an in-flight drag operation, and
 * so shows its loading overlay and refuses drops.
 *
 * Provided per panel rather than board-wide from `useColumnLoading`'s set: the
 * value is a primitive, so a column whose flag is unchanged doesn't re-render.
 * Handing the set itself to every consumer would re-render the whole board on
 * each start and release.
 *
 * A context rather than a prop threaded down from the board, because the slots
 * that need this sit under `InnerListPragmatic`'s `events.map()`: as a prop the
 * flag becomes a dependency of the compiler's memo block for that whole array,
 * so flipping it rebuilds every card element in the column — inside the drop
 * handler, in the frame that is supposed to be showing the drop feedback. Read
 * through the context and the card elements stay cached; only the slots, which
 * genuinely have to re-register their drop target, re-render.
 *
 * Defaults to false: `ActivityPanelPragmatic` is shared with
 * `RosterViewPragmatic`, which has no per-column loading state and provides
 * nothing — its slots read the default and behave exactly as before.
 */
export const ColumnLoadingContext = createContext(false);

export const useIsColumnLoading = () => useContext(ColumnLoadingContext);
